import type { IComponentController, IScope } from "angular";

export class LoadingOverlayComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public isLoading: boolean;

    constructor(private readonly $scope: IScope) {}
}
